var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGmailIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24 6L15.1017 11.7768L6 6V6.00156L6.011 6.00937V14.0984L14.9992 20L24 14.3263V6Z",
    fill: "#EA4335"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25.9068 4.51471L24 6.02871V15L30 9.93993V6.89169C30 6.89169 29.2718 2.5381 25.9068 4.51471Z",
    fill: "#FBBC05"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M24 14.8491V26H28.5976C28.5976 26 29.9059 25.8582 30 24.288V10L24 14.8491Z",
    fill: "#34A853"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M6 5.88193L4.10085 4.47956C0.730899 2.63847 0 6.69202 0 6.69202V9.53117L6 14V5.88193Z",
    fill: "#C5221F"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M0 9V24.1808C0.0927018 25.8509 1.40245 26 1.40245 26H6L5.98954 13.8833L0 9Z",
    fill: "#4285F4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGmailIcon);
export default __webpack_public_path__ + "static/media/GmailIcon.60a57f16d9f9ed02df75b01df3e80ccf.svg";
export { ForwardRef as ReactComponent };